module["exports"] = [
  "BGD",
  "BEL",
  "BFA",
  "BGR",
  "BIH",
  "BRB",
  "WLF",
  "BLM",
  "BMU",
  "BRN",
  "BOL",
  "BHR",
  "BDI",
  "BEN",
  "BTN",
  "JAM",
  "BVT",
  "BWA",
  "WSM",
  "BES",
  "BRA",
  "BHS",
  "JEY",
  "BLR",
  "BLZ",
  "RUS",
  "RWA",
  "SRB",
  "TLS",
  "REU",
  "TKM",
  "TJK",
  "ROU",
  "TKL",
  "GNB",
  "GUM",
  "GTM",
  "SGS",
  "GRC",
  "GNQ",
  "GLP",
  "JPN",
  "GUY",
  "GGY",
  "GUF",
  "GEO",
  "GRD",
  "GBR",
  "GAB",
  "SLV",
  "GIN",
  "GMB",
  "GRL",
  "GIB",
  "GHA",
  "OMN",
  "TUN",
  "JOR",
  "HRV",
  "HTI",
  "HUN",
  "HKG",
  "HND",
  "HMD",
  "VEN",
  "PRI",
  "PSE",
  "PLW",
  "PRT",
  "SJM",
  "PRY",
  "IRQ",
  "PAN",
  "PYF",
  "PNG",
  "PER",
  "PAK",
  "PHL",
  "PCN",
  "POL",
  "SPM",
  "ZMB",
  "ESH",
  "EST",
  "EGY",
  "ZAF",
  "ECU",
  "ITA",
  "VNM",
  "SLB",
  "ETH",
  "SOM",
  "ZWE",
  "SAU",
  "ESP",
  "ERI",
  "MNE",
  "MDA",
  "MDG",
  "MAF",
  "MAR",
  "MCO",
  "UZB",
  "MMR",
  "MLI",
  "MAC",
  "MNG",
  "MHL",
  "MKD",
  "MUS",
  "MLT",
  "MWI",
  "MDV",
  "MTQ",
  "MNP",
  "MSR",
  "MRT",
  "IMN",
  "UGA",
  "TZA",
  "MYS",
  "MEX",
  "ISR",
  "FRA",
  "IOT",
  "SHN",
  "FIN",
  "FJI",
  "FLK",
  "FSM",
  "FRO",
  "NIC",
  "NLD",
  "NOR",
  "NAM",
  "VUT",
  "NCL",
  "NER",
  "NFK",
  "NGA",
  "NZL",
  "NPL",
  "NRU",
  "NIU",
  "COK",
  "XKX",
  "CIV",
  "CHE",
  "COL",
  "CHN",
  "CMR",
  "CHL",
  "CCK",
  "CAN",
  "COG",
  "CAF",
  "COD",
  "CZE",
  "CYP",
  "CXR",
  "CRI",
  "CUW",
  "CPV",
  "CUB",
  "SWZ",
  "SYR",
  "SXM",
  "KGZ",
  "KEN",
  "SSD",
  "SUR",
  "KIR",
  "KHM",
  "KNA",
  "COM",
  "STP",
  "SVK",
  "KOR",
  "SVN",
  "PRK",
  "KWT",
  "SEN",
  "SMR",
  "SLE",
  "SYC",
  "KAZ",
  "CYM",
  "SGP",
  "SWE",
  "SDN",
  "DOM",
  "DMA",
  "DJI",
  "DNK",
  "VGB",
  "DEU",
  "YEM",
  "DZA",
  "USA",
  "URY",
  "MYT",
  "UMI",
  "LBN",
  "LCA",
  "LAO",
  "TUV",
  "TWN",
  "TTO",
  "TUR",
  "LKA",
  "LIE",
  "LVA",
  "TON",
  "LTU",
  "LUX",
  "LBR",
  "LSO",
  "THA",
  "ATF",
  "TGO",
  "TCD",
  "TCA",
  "LBY",
  "VAT",
  "VCT",
  "ARE",
  "AND",
  "ATG",
  "AFG",
  "AIA",
  "VIR",
  "ISL",
  "IRN",
  "ARM",
  "ALB",
  "AGO",
  "ATA",
  "ASM",
  "ARG",
  "AUS",
  "AUT",
  "ABW",
  "IND",
  "ALA",
  "AZE",
  "IRL",
  "IDN",
  "UKR",
  "QAT",
  "MOZ"
];